import type React from "react";
import { useEffect, useState } from "react";
import type { SelectedApp } from "~/interface/reverse";
import { DrawioContainer } from "../../Document/drawioView";
import styles from "./index.module.scss";

interface ERDiagramData {
  xml?: string;
  [key: string]: unknown;
}

interface ERDiagramProps {
  selectedApps: SelectedApp[];
  diagramData?: ERDiagramData;
  onExport?: () => void;
  onEdit?: () => void;
  isOtherTabEditing?: boolean;
  onEditingChange?: (isEditing: boolean) => void;
}

const ERDiagram: React.FC<ERDiagramProps> = ({ selectedApps, diagramData }) => {
  const [erDiagramXml, setErDiagramXml] = useState<string>("");

  useEffect(() => {
    const loadERDiagram = () => {
      try {
        // Use provided diagram data if available
        if (diagramData) {
          // If diagramData is an object with xml property
          if (diagramData?.xml) {
            setErDiagramXml(diagramData.xml);
          }
        }
      } catch (error) {
        console.error("Failed to load ER diagram:", error);
      }
    };

    if (diagramData) {
      loadERDiagram();
    }
  }, [diagramData]);

  return (
    <div className={styles["container"]}>
      {erDiagramXml ? (
        // 編集・エクスポート機能は無効化済み
        <DrawioContainer
          xml={erDiagramXml}
          documentType="er-diagram"
          documentName={`ER図_${selectedApps.map((app) => app.name).join("_")}`}
        />
      ) : (
        <div className={styles["loading"]}>
          {diagramData === undefined ? "ER図データを取得中..." : "ER図データが利用できません"}
        </div>
      )}
    </div>
  );
};

export default ERDiagram;
